import store from '@/store';

function isAuthenticated() {
  const { token } = localStorage;
  return store.dispatch('TOKEN_AUTHENTICATION', { token });
}

const authenticationBeforeRouting = (to, from, next) => {
  if (to.path === '/login') {
    return next();
  }

  return isAuthenticated()
    .then(() => {
      Promise.all([
        store.dispatch('FETCH_PERMISSIONS'),
        store.dispatch('FETCH_GROUP_PERMISSIONS'),
        store.dispatch('features/FETCH_FEATURES'),
        store.dispatch('features/FETCH_FEATURE_CONFIGURATIONS'),
      ]).then(() => {
        const hasAccessTo = store.getters['features/hasAccessTo'];
        const hasUXTesterRole = store.getters.has_ux_tester_role_enabled;

        if (hasUXTesterRole) {
          next();
          return;
        }

        if (!hasAccessTo(to.name)) {
          next({ name: store.getters['features/defaultRoute'] });
          return;
        }

        next();
      });
    })
    .catch(() => {
      next('/login');
    });
};

export default authenticationBeforeRouting;
